import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Filter",
  "use": "svg-icon-Filter-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"svg-icon-Filter\"><path fill=\"#333\" d=\"M14.936.416c-.12-.277-.33-.416-.628-.416H.692C.394 0 .185.139.064.416c-.12.29-.07.54.149.745l5.245 5.252v5.178c0 .185.067.344.202.48l2.723 2.726a.632.632 0 0 0 .479.203.74.74 0 0 0 .266-.053c.276-.121.415-.33.415-.629V6.413l5.244-5.252c.22-.206.27-.454.149-.745z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol